<template>
  <v-menu
    rounded="lg"
    absolute
    offset-y
    :disabled="isUpdating || restrictPlaylistAccess"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-icon v-bind="attrs" v-on="on" class="mr-3">mdi-cog</v-icon>
    </template>
    <v-card
      class="mx-auto"
      width="200"
      max-width="207"
      tile>
      <v-list>
        <v-list-item-group
          color="primary">
          <v-list-item
            class="mb-n2 playlist-bulb-settings"
            :disabled="isUpdating || restrictPlaylistAccess || !hasBulbEditAccess || bulbIsLMB"
            @click="handleBulbSettings()">
            <v-list-item-icon
              v-if="!showSlideout"
              class="mr-2"
              :disabled="isUpdating || restrictPlaylistAccess">
              <v-icon>mdi-cog</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="">
              <v-list-item-title>
                Bulb Settings
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            class="mb-n2 edit-playlist-bulb"
            @click="handleEditBulb()"
            :disabled="isUpdating || restrictPlaylistAccess || !hasBulbEditAccess || bulbIsLMB">
            <v-list-item-icon
              v-if="!showSlideout"
              class="mr-2">
              <v-icon>mdi-pencil</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="">
              <v-list-item-title>
                Edit Bulb
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            class="mb-n2 delete-playlist-bulb"
            :disabled="isUpdating || restrictPlaylistAccess"
            @click="handleRemoveBulb()">
            <!-- delete the bulb from playlist -->
            <v-list-item-icon
              v-if="!showSlideout"
              class="mr-2"
              aria-label="Remove bulb from playlist">
              <v-icon>mdi-delete</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Remove Bulb
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>

import {
  mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from 'vuex';

import _ from 'lodash';

export default {
  name: 'ScoreThresholdSettings',
  props: {
    bulbSettings: {
      type: Object,
      default() {
        return {};
      },
    },
    moduleBulb: {
      type: Object,
      default() {
        return {};
      },
    },
    handleRemoveBulb: {
      type: Function,
      default: () => {},
    },
    handleEditBulb: {
      type: Function,
      default: () => {},
    },
    clearedScoreThreshold: {
      type: Boolean,
      default: false,
    },
    pointsAvailable: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      serverURL: this.$getServerUrl(),
      scoreThresholdPlaceholder: '',
      bulbSettingsDialog: false,
    };
  },
  methods: {
    ...mapMutations([
      'setSlideout',
    ]),
    ...mapActions([
      'removeItem',
      'updateItem',
    ]),
    handleScoreThresholdPlaceholder() {
      if (this.moduleBulb.config?.scoreThreshold) this.scoreThresholdPlaceholder = `${_.get(this, 'moduleBulb.config.scoreThreshold')}`;
    },
    handleBulbScoreThresholdOption(data) {
      this.updateItem({
        moduleId: this.moduleBulb.moduleId,
        itemId: this.moduleBulb.itemId,
        itemConfig: {
          scoreThreshold: data.scoreThreshold,
        },
      });
    },
    async handleBulbSettings() {
      this.setSlideout({
        type: 'playlistBulbSettings',
        module: this.moduleBulb,
        bulb: this.moduleBulb.bulb,
        pointsAvailable: this.pointsAvailable,
        handlePlaylistBulbScoreThreshold: this.handleBulbScoreThresholdOption,
      });
    },
  },
  computed: {
    ...mapState([
      'isUpdating',
      'passbackBulbs',
      'playlistId',
      'playlist',
      'showSlideout',
      'user',
    ]),
    ...mapGetters([
      'restrictPlaylistAccess',
    ]),
    bulbIsLMB() {
      return _.get(this, 'moduleBulb.bulb.lmbId', 0) === 1;
    },
    hasBulbEditAccess() {
      return (
        !this.restrictPlaylistAccess
        || [1, 2].includes(_.get(this, 'moduleBulb.bulb.teachers[0].bulbTeacher.bulbRole', 0))
      );
    },
    scoreThreshold: {
      get() {
        return this.moduleBulb.config?.scoreThreshold;
      },
      set(value) {
        this.$set(this.moduleBulb.config, 'scoreThreshold', value);
      },
    },
    scoreThresholdString() {
      const scoreThreshold = _.isFinite(this.scoreThreshold) ? this.scoreThreshold : +this.scoreThresholdPlaceholder;
      const pointsThreshold = Math.ceil((scoreThreshold / 100) * this.pointsAvailable);
      return `
      ${!this.isScoreThresholdToggleEnabled ? 'If enabled, learners' : 'Learners'}
      will need to earn at least ${pointsThreshold} of the ${this.pointsAvailable} available 
      point${this.pointsAvailable === 1 ? '' : 's'} on this bulb.
      `;
    },
    scoreThresholdError() {
      if (
        this.isScoreThresholdToggleEnabled
        && !_.isFinite(this.scoreThreshold)
      ) return ['Score threshold must be a valid number between 1 and 100.'];
      return [];
    },
    moduleItemHasScoreThreshold() {
      return !!this.moduleBulb.config?.scoreThreshold;
    },
  },
  mounted() {
    this.handleScoreThresholdPlaceholder();
  },
};
</script>

<style lang="scss" scoped></style>
